import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType, NbMassiveItem} from './nbinput.entity';

@Component({
  selector: 'nbinput-choose',
  template: require('./nbinput-choose.component.html'),
  styles: [require('./nbinput-choose.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputChooseComponent),
      multi: true
    }
  ]
})

export class NbinputChooseComponent implements ControlValueAccessor {
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if (fn) {this.onChangeCallback = fn; }}
  registerOnTouched(fn: any): void {if (fn) {this.onTouchedCallback = fn; }}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj): void {
    this.checked = !!obj;
  }
  onBlur() { this.onTouchedCallback(); }
  public disabled = false;
  @Input() public readonly = false;

  FieldType = NbFieldType;
  @Input() public type?: NbFieldType = NbFieldType.Checkbox;
  @Input() public text: string;
  @Input() checked = false;
  get value(): any {
    return this.checked;
  };
  set value(v: any) {
    this.checked = !!v;
    this.onChangeCallback(v);
  }
  @Output() public onChange: EventEmitter<any> = new EventEmitter();
  changed(e) {
    console.log('checked: ', e.target.checked);
    this.onChange.emit(e.target.checked);
    this.onChangeCallback(e.target.checked);
  }
}
